module.exports = __webpack_public_path__ + "img/page9.851856f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tax/page9.png
// module id = J7gW
// module chunks = 0